import { handleResponse } from './responseHandler';

async function fetchHandler(resourceURL, options) {
    return await fetch(resourceURL, options);
}

function kebabCaseToCamel(str) {
  return str.replace(/(-\w)/g, (matches) => matches[1].toUpperCase());
}

class API {
  constructor({ url }) {
    this.url = url;
    this.endpoints = {};
  }

  /**
   * Create and store a single entity's endpoints
   * @param {A entity Object} entity
   */
  createEntity(entity) {
    /**
     * If there is a - in the entity.name, then change it
     * to camelCase. E.g
     * ```
     * myApi.createEntity({ name : 'foo-bar'})
     * myApi.endpoints.fooBar.getAll(...)
     */

    const name = kebabCaseToCamel(entity.name);
    this.endpoints[name] = this.createBasicCRUDEndpoints(entity.route?entity.route:entity.name);
  }

  createEntities(arrayOfEntity) {
    arrayOfEntity.forEach(this.createEntity.bind(this));
  }

  /**
   * Create the basic endpoints handlers for CRUD operations
   * @param {A entity Object} entity
   */
  createBasicCRUDEndpoints(name) {
    const endpoints = {};

    const resourceURL = `${this.url}/${name}`;

    endpoints.get = (options = {
      crossDomain: true,
      method: 'GET',
      headers: {
        Accept: 'application/json',
      }
    }) => (
      async () => {
        const response = await fetchHandler(resourceURL, options);
        const responseOK = await handleResponse(response);
        if(!responseOK){
          throw new Error(`Failed to fetch: ${resourceURL}`);
        }return response.json();
      }
    );

    endpoints.getMultipleQueryString = (queries, options = {
      crossDomain: true,
      method: 'GET',
      headers: {
        Accept: 'application/json',
      }
    }) => (
      async () => {
        const response = await fetchHandler(`${resourceURL}?${
          queries.map((currentValue, index, array) => {
            if (array.length - 1 === index) {
              return `${currentValue.queryParam}=${currentValue.queryVal}`;
            }
            return `${currentValue.queryParam}=${currentValue.queryVal}&`;
        }).join('')}`, options, this.scopes
        );
        return response.json()
      }
    );

    endpoints.post = (body, options = {
      crossDomain: true,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }) => (
      async () => {
        const response = await fetchHandler(resourceURL, options);
        const responseOK = await handleResponse(response);
        if(!responseOK){
          throw new Error(`Failed to fetch: ${resourceURL}`);
        }return response.json();
      }
    );

    endpoints.postMultipleQueryString = (queries, options = {
      crossDomain: true,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }) => (
      async () => {
        const response = await fetchHandler(`${resourceURL}?${
          queries.map((currentValue, index, array) => {
            if (array.length - 1 === index) {
              return `${currentValue.queryParam}=${currentValue.queryVal}`;
            }
            return `${currentValue.queryParam}=${currentValue.queryVal}&`;
        }).join('')}`, options, this.scopes);
        const responseOK = await handleResponse(response);
        if(!responseOK){
          throw new Error(`Failed to fetch: ${resourceURL}`);
        }return response.json();
      }
    );

    return endpoints;
  }
}

export default API;